import type { PcmBuffer } from './types';

export function reverse(pcm: PcmBuffer): PcmBuffer {
  const channels = pcm.channels.map((ch) => {
    const dst = new Float32Array(ch.length);
    for (let i = 0; i < ch.length; i++) {
      dst[i] = ch[ch.length - 1 - i]!;
    }
    return dst;
  });
  return { sampleRate: pcm.sampleRate, channels };
}
